const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[var(--cb-bg-2)]">
      <div className="max-w-[1100px] mx-auto px-6 py-12 text-center">
        <div className="flex justify-center">
          <img src="/assets/art/cherubim-logo.png" alt="CHERUBIM" className="h-[18px] w-auto opacity-90" />
        </div>
        <div className="font-serif italic text-[var(--cb-text-dim)] mt-3 text-[15px]">
          They tried to erase his name. But heaven remembers.
        </div>
        <div className="font-caps text-[10px] text-[var(--cb-text-muted)] mt-6">
          © {new Date().getFullYear()} ASHECRAFT INTERNATIONAL · ALL RIGHTS RESERVED
        </div>
      </div>
    </footer>
  );
};

export default Footer;
